/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { FileStatus } from "@vienna/common";

import { FileBlock, ImageBlock } from "src/classes/block/block-types";
import { ErrorBlock } from "src/components/Block/Placeholders/ErrorBlock";
import { UploadProgress } from "src/components/Block/Placeholders/UploadProgress";

interface Props {
  block: FileBlock | ImageBlock;
  children: React.ReactNode | React.ReactNode[];
  fallbackComponent?: React.ReactNode;
}

export function FileStatusWrapper({ block, children, fallbackComponent }: Props) {
  const fileStatus = block.observe((state) => state.fileStatus);
  const uploadPercent = block.observe((state) => state.uploadPercent);
  return (
    <>
      {(() => {
        switch (fileStatus) {
          case FileStatus.Uploaded:
            return children;
          case FileStatus.Uploading:
            return <UploadProgress uploadPercent={uploadPercent} />;
          case FileStatus.Failed:
            return <ErrorBlock msg={`${block.snapshot.type} not found`} />;
          case FileStatus.None:
            return fallbackComponent || <ErrorBlock msg={`${block.snapshot.type} not found`} />;
          default:
            return <ErrorBlock msg={`${block.snapshot.type} not found`} />;
        }
      })()}
    </>
  );
}
